const week = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
const month = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']

const forwardCss = `
    font-size: 12px;
    background:#efefef;
    width: 90%;
    padding: 6px 8px;
    border-radius: 6px;
    margin: 10px 0
`

/** 回复和转发邮件初始头部信息 */
export const getDivider = (
	emailFrom: string,
	date: Date,
	type?: boolean,
	subject?: string,
	to?: string
) => {
	if (!type) {
		/** 回复邮件 */
		return `<div style="font-size: 12px;">On ${week[date.getDay()]}, ${
			month[date.getMonth()]
		} ${date.getDate()}, ${date.getFullYear()} at ${date.getHours() % 12 || 12}:${
			date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
		} ${date.getHours() >= 12 ? 'PM' : 'AM'} ${emailFrom
			.replace('<', '&lt;')
			.replace('>', '&gt;')} wrote:</div>`
	} else {
		/** 转发邮件 */
		return `<div style="font-size: 12px;">---------- Forwarded Message ----------</div>
      <div style="${forwardCss}">
        From: ${emailFrom.replace('<', '&lt;').replace('>', '&gt;')}<br/>
        Date: ${week[date.getDay()]}, ${
			month[date.getMonth()]
		} ${date.getDate()}, ${date.getFullYear()} at ${date.getHours() % 12 || 12}:${
			date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
		} ${date.getHours() >= 12 ? 'PM' : 'AM'}<br/>
        Subject: ${subject}<br/>
        To: ${to?.replace('<', '&lt;')?.replace('>', '&gt;')}
      </div>`
	}
}

export const extractBlockquote = (html: string) => {
	const parser = new DOMParser()
	const doc = parser.parseFromString(html, 'text/html')

	/** Blockquote */
	const allBlockquotes = Array.from(doc.querySelectorAll('blockquote'))

	/** 提取正文去掉最外层Blockquote */
	let bodyContent = ''
	const firstBlockquote = allBlockquotes[0]
	if (firstBlockquote) {
		// clone body
		const cloned = doc.body.cloneNode(true) as HTMLElement
		const blockquoteInClone = cloned.querySelector('blockquote')
		if (blockquoteInClone) {
			blockquoteInClone.remove()
		}
		bodyContent = cloned.innerHTML.trim()
	} else {
		bodyContent = doc.body.innerHTML.trim()
	}

	/** 提取最外层Blockquote */
	let outer = ''
	let inner = ''
	if (firstBlockquote) {
		outer = firstBlockquote.innerHTML.trim()

		let nested = firstBlockquote.querySelector('blockquote')
		inner = outer
		while (nested) {
			inner = nested.innerHTML.trim()
			nested = nested.querySelector('blockquote')
		}
	}

	return { body: bodyContent, outer, inner }
}

/** 格式化回复标识，避免多次回复叠加Re/Fwd这些 */
export const formatSubjectPrefix = (subject: string, type: 'RE' | 'FWD') => {
	if (!subject) return ''

	const prefix = type === 'RE' ? 'Re:' : 'Fwd:'

	/** 去掉开头所有重复前缀 */
	const regex = new RegExp(`^((${prefix}\\s*)+)?`, 'i')
	const cleanSubject = subject.replace(regex, '').trim()

	return `${prefix} ${cleanSubject}`
}
